// extracted by mini-css-extract-plugin
module.exports = {"card":"styles-module--card--1vc51","icon":"styles-module--icon--fC25A","title":"styles-module--title--3zFjo","description":"styles-module--description--2a9FZ"};